import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import React, { useCallback, useMemo } from 'react';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
import isInvalidViewData from 'app/components/swipeableViews/isInvalidViewData';
import MediaView from 'app/components/mediaModule/content/MediaView';
import { splitIntoEqualChunks } from 'app/components/swipeableViews/splitArrayIntoChunks';
const SwipeableMediaList = _ref => {
  let {
    data
  } = _ref;
  const {
    updateTrackingData
  } = useDistrictMainPageTracking();
  const viewData = useMemo(() => {
    return splitIntoEqualChunks(data);
  }, [data]);
  const createView = useCallback((mediaList, index) => /*#__PURE__*/React.createElement(MediaView, {
    key: "media-view-".concat(index),
    mediaList: mediaList,
    pageIndex: index
  }), []);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    if (isInvalidViewData(viewData, index)) {
      return null;
    }
    return createView(viewData[index], index);
  }, [viewData, createView]);
  const callback = useCallback(data => updateTrackingData(DistrictMainPageModuleType.MEDIA, data), [updateTrackingData]);
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    callback: callback,
    stepCount: viewData.length,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "SwipeableMediaList",
    "data-sentry-source-file": "SwipeableMediaList.tsx"
  });
};
export default SwipeableMediaList;